// extracted by mini-css-extract-plugin
export default {"Button":"IconButton_Button__Aok9U","Text":"IconButton_Text__M-VZ0","Icon":"IconButton_Icon__4RNpK","Root":"IconButton_Root__1CIPl"};